import { formatISODate } from '@strength/utils';
import { MdCalendarMonth } from '@teamworksdev/icons';
import { getLocale } from '../../utils/i18n';
import { DateRange, RangeCalendar } from './RangeCalendar';

export function RangeCalendarSelect({
  value,
  onChange,
  maxUniqueMonths,
  minDate,
  maxDate,
}: {
  value: DateRange | null;
  onChange?: (dateRange: DateRange | null) => void;
  /** When set, the selected range may span at most this many unique calendar months. */
  maxUniqueMonths?: number;
  /** When set, the selected range cannot start before this date (ISO). */
  minDate?: string;
  /** When set, the selected range cannot end after this date (ISO). */
  maxDate?: string;
}) {
  const label =
    value?.start && value?.end
      ? `${formatISODate(value.start, getLocale())}-${formatISODate(
          value.end,
          getLocale(),
        )}`
      : '';

  return (
    <RangeCalendar
      label={label}
      labelProps={{
        variant: 'outlined',
        endIcon: <MdCalendarMonth />,
        className: 'font-normal',
      }}
      value={value}
      onChange={onChange}
      maxUniqueMonths={maxUniqueMonths}
      minDate={minDate}
      maxDate={maxDate}
    />
  );
}
